import React, {useEffect, useRef, useState} from 'react';
import {useDispatch, useSelector} from "react-redux";
import {useNavigate, useParams} from "react-router-dom";
import {Button, Checkbox, Flex, Form, Input, message, Modal, Popconfirm, Table, Upload} from 'antd';
import {createStyles} from 'antd-style';
import IntlMessage from "../../../../../components/IntlMessage/IntlMessage";
import MyText from "../../../../../components/UI/Text/MyText";
import classes from "../../Applications/application.module.css";
import JournalService from "../../../../../services/JournalService";
import GroupService from "../../../../../services/GroupService";
import {getJournal} from "../../../../../store/slices/TeacherGroupSlice";
import BlockLoading from "../../../../../components/LoadingComponents/BlockLoading";
import FormItem from "antd/es/form/FormItem";
import {EditOutlined, PlusOutlined} from "@ant-design/icons";
import {useTranslation} from "react-i18next";
import GreenButton from "../../../../../components/UI/Buttons/GreenButton";
import GreyButton from "../../../../../components/UI/Buttons/GreyButton";
import StudentScheduleModal from "../../../../../components/UI/StudentScheduleModal/StudentScheduleModal";

const useStyle = createStyles(({css, token}) => {
    const {antCls} = token;
    return {
        customTable: css`
            ${antCls}-table {
                ${antCls}-table-container {
                    ${antCls}-table-body,
                    ${antCls}-table-content {
                        scrollbar-width: thin;
                        scrollbar-color: #eaeaea transparent;
                        scrollbar-gutter: stable;
                    }
                }
            }
        `,
    };
});
const EditableCell = ({
                          editing,
                          dataIndex,
                          title,
                          inputType,
                          record,
                          index,
                          children,
                          ...restProps
                      }) => {
    const inputNode = inputType === 'date' ? <Input type={'date'}/> : <Input/>;
    return (
        <td {...restProps}>
            {editing ? (
                <Form.Item
                    name={dataIndex}
                    style={{margin: 0}}
                    rules={[
                        {
                            required: true,
                            message: <IntlMessage id={"tg.emptyInput"}/>,
                        },
                    ]}
                >
                    {inputNode}
                </Form.Item>
            ) : (
                children
            )}
        </td>
    );
};
const JournalPage = () => {
    const {t} = useTranslation();

    const {id} = useParams()
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const {journal, isLoading} = useSelector(state => state.teacherGroup);
    const {user} = useSelector(state => state.user);

    const [form] = Form.useForm();
    const name = Form.useWatch('name', form);
    const date = Form.useWatch('date', form);
    const moduleName = Form.useWatch('moduleName', form);

    const [formAttendance] = Form.useForm();
    const attendanceValues = Form.useWatch([], formAttendance); // следим за всей формой

    const [reasonForm] = Form.useForm();
    const reason = Form.useWatch('reason', reasonForm);
    const raasonValues = Form.useWatch([], reasonForm); // следим за всей формой


    const [editingKey, setEditingKey] = useState('');
    const [selectedRowKeys, setSelectedRowKeys] = useState([]);
    const [selectedAttendances, setSelectedAttendances] = useState([]);

    const [openNoteLessonModal, setOpenNoteLessonModal] = useState(false)
    const [noteLesson, setNoteLesson] = useState(null)
    const [isViewNote, setIsViewNote] = useState(false)
    const isEditing = record => record.key === editingKey;
    const getAttendanceFieldName = id => `attendance-${id}`;

    const [lessonAddForm] = Form.useForm();
    const lessonsForJournals = Form.useWatch('lessonsForJournals', lessonAddForm);
    const lessonNumberAddLesson = Form.useWatch('lessonNumberAddLesson', lessonAddForm);
    const topicNameAddLesson = Form.useWatch('topicNameAddLesson', lessonAddForm);
    const moduleNameAddLesson = Form.useWatch('moduleNameAddLesson', lessonAddForm);
    const lessonDateAddLesson = Form.useWatch('lessonDateAddLesson', lessonAddForm);

    const [uploadedFile, setUploadedFile] = useState(null);


    const [openAddLessonModal, setOpenAddLessonModal] = useState(false)
    const [isAdminEditMode, setIsAdminEditMode] = useState(false)

    // п.7: даты присоединения учеников (studentId -> 'YYYY-MM-DD') для пометки ☁️
    const [joinDates, setJoinDates] = useState({});

    // п.10: модалка полного расписания ученика
    const [openSchedule, setOpenSchedule] = useState(false);
    const [scheduleStudent, setScheduleStudent] = useState(null);

    useEffect(() => {
        if (!journal?.group?.id) return;
        GroupService.getGroupEnrollments(journal.group.id)
            .then((d) => {
                const map = {};
                (d?.enrollments || []).forEach(e => {
                    // п.7: строка 'YYYY-MM-DD' + сравнение по календарной дате — без таймзонного off-by-one
                    if (e.joinDate) map[e.studentId] = String(e.joinDate).slice(0, 10);
                });
                setJoinDates(map);
            })
            .catch(() => setJoinDates({}));
    }, [journal?.group?.id]);

    function formatDateDDMMYYYY(dateInput) {
        const date = new Date(dateInput);
        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0'); // Месяцы с 0
        const year = date.getFullYear();

        return `${year}-${month}-${day}`;
    }

    const edit = record => {

        const initValues = {
            ...record,
            date: record.date ? formatDateDDMMYYYY(record.date) : null,
        };

        form.setFieldsValue(initValues);
        setEditingKey(record.key);
    };
    const cancel = () => {
        setEditingKey('');
    };
    const save = async record => {
        form.validateFields().then(async () => {
            await JournalService.updateLesson(record.key, date, record.journal_id, name)
                .then(() => {
                    message.success(<IntlMessage id={'success'}/>, 5);
                    form.resetFields();
                })
                .catch(() => {
                    message.error(<IntlMessage id={'error'}/>, 5);
                })
                .finally(() => {
                    dispatch(getJournal({id}));
                    setEditingKey('');
                })
        })
            .catch(() => {
                console.log("Validation error!")
            })
    };

    const updateLesson = async key => {
        await JournalService.updateLesson(key)
            .then(() => {
                message.success(<IntlMessage id={'success'}/>, 5);
                form.resetFields();
            })
            .catch(() => {
                message.error(<IntlMessage id={'error'}/>, 5);
            })
            .finally(() => {
                dispatch(getJournal({id}));
                setEditingKey('');
            })
    }

    const {styles} = useStyle();
    const baseColumn = {
        title: <MyText center><IntlMessage id={"fullName"}/></MyText>,
        width: 200,
        dataIndex: 'name',
        key: 'name',
        fixed: 'left',
        // п.10: клик по ФИО открывает полное расписание ученика по всем дисциплинам
        render: (_, record) => (
            <span
                style={{cursor: 'pointer', color: '#1677ff'}}
                onClick={() => {
                    setScheduleStudent({id: record.studentId, name: record.name});
                    setOpenSchedule(true);
                }}
            >
                {record.name}
            </span>
        ),
    };
    const lessonColumns = journal?.lessons
        ?.filter(lesson => lesson.date !== null) // ✅ отсекаем null-даты
        .map(lesson => ({
            title: (
                <Flex style={{cursor: "pointer"}} align={"center"} justify={"center"} gap={"small"} onClick={() => {
                    const currentValues = formAttendance.getFieldsValue();
                    const allIds = lesson.attendances.map(att => getAttendanceFieldName(att.id));
                    const allChecked = allIds.every(id => currentValues[id]);
                    lesson.attendances.forEach(att => {
                        formAttendance.setFieldValue(getAttendanceFieldName(att.id), !allChecked);
                    });
                }}>
                    <MyText center>
                        {new Date(lesson.date).toLocaleDateString("ru-RU")}
                    </MyText>
                </Flex>
            ),
            dataIndex: lesson.number,
            key: lesson.number
        })) || [];

    const columns1 = [baseColumn, ...lessonColumns];
    const columns2 = [
        {
            title: <MyText center><IntlMessage id={"tg.dateOfLesson"}/></MyText>,
            width: '20%',
            dataIndex: 'date',
            key: 'date',
            editable: true,
            render: (_, record) => (
                <p>
                    {record.date ? new Date(record.date).toLocaleDateString('kk-KZ') : ""}
                </p>
            ),
        },
        {
            title: <MyText center><IntlMessage id={"tg.nameOfLesson"}/></MyText>,
            width: '30%',
            dataIndex: 'name',
            key: 'name',
            editable: true
        },
        {
            title: <MyText center><IntlMessage id={"tg.moduleOfLesson"}/></MyText>,
            width: '30%',
            dataIndex: 'moduleName',
            key: 'moduleName',
            editable: false
        },
        {
            title: <MyText center><IntlMessage id={"actions"}/></MyText>,
            key: 'action',
            fixed: 'right',
            width: '20%',
            render: (_, record) => {
                const editable = isEditing(record);
                return record.isDone ? <IntlMessage id={'finished'}/>
                    : editable ? (
                        <span>
                        <p onClick={() => save(record)} className={classes.copyLinkBtn}>
                        <IntlMessage id={'save'}/>
                        </p>
                        <p onClick={() => cancel()} className={classes.rejectBtn}>
                        <IntlMessage id={'cancel'}/>
                        </p>
                    </span>
                    ) : (
                        <span>
                         <p onClick={() => edit(record)} className={classes.copyLinkBtn}>
                        <IntlMessage id={'edit'}/></p>
                            {(journal?.group?.category?.nameEng !== 'General English' && journal?.group?.category?.nameEng !== 'Mathematics') &&
                                record.date !== null &&
                                <Popconfirm
                                    title={t('finishLesson')}
                                    description={t('youSureToFinishLesson')}
                                    onConfirm={() => {
                                        updateLesson(record.key)
                                    }}
                                    // className={classes.deleteBlock}
                                    okText={t('yes')}
                                    cancelText={t('no')}
                                >
                                    <p className={classes.copyLinkBtn}>
                                        <IntlMessage id={'finishLesson'}/></p>
                                </Popconfirm>
                            }
                    </span>
                    );

            },
        },
    ];
    const mergedColumns = columns2.map(col => {
        if (!col.editable) return col;

        return {
            ...col,
            onCell: record => ({
                record,
                inputType: col.dataIndex === 'date' ? 'date' : 'text',
                dataIndex: col.dataIndex,
                title: col.title,
                editing: isEditing(record),
            }),
        };
    });
    const dataSource1 = journal?.group?.students?.map((student, index) => {
        const row = {
            key: String(index + 1),
            name: `${student?.profile?.fullName}`, // если имя разбито
            studentId: student.id,
        };

        const studentJoinDate = joinDates[student.id]; // 'YYYY-MM-DD' | undefined

        journal.lessons?.forEach((lesson) => {
            // п.7: уроки до присоединения помечаем ☁️ и не даём отмечать посещаемость (сравнение по календарной дате)
            if (studentJoinDate && lesson?.date && String(lesson.date).slice(0, 10) < studentJoinDate) {
                row[lesson.number] = <span title="До присоединения">☁️</span>;
                return;
            }
            const attendance = lesson.attendances.find(a => a.user.id === student.id);
            // Разрешаем редактирование если: урок не завершен ИЛИ (урок завершен И админ в режиме редактирования)
            const canEdit = lesson?.date !== null && (!lesson?.isDone || (lesson?.isDone && isAdminEditMode && user?.role?.roleName === 'admin'));

            if (canEdit) {
                row[lesson.number] =
                    <Flex gap={"middle"} justify={"center"} style={{textAlign: 'center'}}>
                        <FormItem valuePropName={"checked"} name={getAttendanceFieldName(attendance?.id)}
                                  style={{marginBottom: 0}}
                                  initialValue={attendance?.isPresent}>
                            <Checkbox/>
                        </FormItem>
                        <EditOutlined onClick={() => {
                            setNoteLesson(attendance);
                            setOpenNoteLessonModal(true);
                            reasonForm.setFieldsValue({
                                reason: attendance?.reasonOfAbsent || ''
                            });
                        }} style={{cursor: "pointer"}}/>
                    </Flex>
            } else {
                row[lesson.number] = attendance ? (attendance.isAbsentForReason ? <span
                    style={{cursor: "pointer"}}
                    onClick={() => {
                        setIsViewNote(true);
                        setOpenNoteLessonModal(true);
                        reasonForm.setFieldsValue({
                            reason: attendance?.reasonOfAbsent || ''
                        });
                    }}>✴️</span> : (attendance.isPresent ? '✅' : '❌')) : '-';
            }
        });

        return row;
    }) || [];

    const dataSource2 = journal?.lessons?.map((lesson, index) => {
        const row = {
            key: lesson.id,
            date: lesson?.date,
            journal_id: lesson?.journalTopic.id,
            // : <MyText center>{new Date(lesson.date).toLocaleDateString()}</MyText>,
            name: `${lesson?.journalTopic?.name}`,
            moduleName: `${lesson?.journalTopic?.moduleName}`,
            isDone: lesson.isDone
        };
        return row;
    }) || [];

    const tableRef = useRef();

    useEffect(() => {
        const tableContainer = tableRef.current?.querySelector('.ant-table-content');
        if (!tableContainer) return;

        let isDown = false;
        let startX = 0;
        let scrollLeft = 0;

        const onMouseDown = (e: MouseEvent) => {
            isDown = true;
            startX = e.pageX - tableContainer.offsetLeft;
            scrollLeft = tableContainer.scrollLeft;
            tableContainer.style.cursor = 'grabbing';
            tableContainer.style.userSelect = 'none';
        };

        const onMouseLeave = () => {
            isDown = false;
            tableContainer.style.cursor = '';
            tableContainer.style.userSelect = '';
        };

        const onMouseUp = () => {
            isDown = false;
            tableContainer.style.cursor = '';
            tableContainer.style.userSelect = '';
        };

        const onMouseMove = (e: MouseEvent) => {
            if (!isDown) return;
            e.preventDefault();
            const x = e.pageX - tableContainer.offsetLeft;
            const walk = (x - startX) * 1; // скорость прокрутки
            tableContainer.scrollLeft = scrollLeft - walk;
        };

        tableContainer.addEventListener('mousedown', onMouseDown);
        tableContainer.addEventListener('mouseleave', onMouseLeave);
        tableContainer.addEventListener('mouseup', onMouseUp);
        tableContainer.addEventListener('mousemove', onMouseMove);

        return () => {
            tableContainer.removeEventListener('mousedown', onMouseDown);
            tableContainer.removeEventListener('mouseleave', onMouseLeave);
            tableContainer.removeEventListener('mouseup', onMouseUp);
            tableContainer.removeEventListener('mousemove', onMouseMove);
        };
    }, []);

    const initialAttendanceValues = {};

    useEffect(() => {
        if (!journal) return;

        const initialValues = {};
        journal.lessons?.forEach(lesson => {
            lesson.attendances.forEach(att => {
                initialValues[`attendance-${att.id}`] = att.isPresent;
            });
        });

        formAttendance.setFieldsValue(initialValues); // обновляем форму вручную
    }, [journal]);

    async function saveAttendances() {
        const values = formAttendance.getFieldsValue(); // { attendance-id: true/false }


        // const selectedIds = Object.entries(values)
        //     .filter(([key, value]) => key.startsWith('attendance-') && value)
        //     .map(([key]) => key.replace('attendance-', ''));
        const attendanceMap = Object.entries(values)
            .filter(([key, value]) => key.startsWith('attendance-') && value !== null && value !== undefined)
            .reduce((acc, [key, value]) => {
                const id = key.replace('attendance-', '');
                acc[id] = value;
                return acc;
            }, {});

        await JournalService.saveAttendances(attendanceMap)
            .then(() => {
                message.success(<IntlMessage id="success"/>, 5);
            })
            .catch(() => {
                message.error(<IntlMessage id="error"/>, 5);
            })
            .finally(() => {
                formAttendance.resetFields(); // сбросить форму (чекбоксы)
                setIsAdminEditMode(false); // выключаем режим редактирования админа
                dispatch(getJournal({id}));
            });
    }

    async function makeAbsentForReason() {
        await JournalService.makeAbsentForReason(noteLesson.id, reason)
            .then(() => {
                message.success(<IntlMessage id="success"/>, 5);
            })
            .catch(() => {
                message.error(<IntlMessage id="error"/>, 5);
            })
            .finally(() => {
                setOpenNoteLessonModal(false);
                setNoteLesson(null);
                setIsViewNote(false)
                formAttendance.setFieldValue(getAttendanceFieldName(noteLesson.id), true);
                reasonForm.resetFields();
                // dispatch(getJournal({id}));
            });
    }

    async function finishAllLessons() {
        message.loading(<IntlMessage id={'changing'}/>, 0);
        await JournalService.finishAllLessons(id)
            .then(() => {
                message.destroy();
                message.success(<IntlMessage id="success"/>, 5);
            })
            .catch(() => {
                message.destroy();
                message.error(<IntlMessage id="error"/>, 5);
            })
            .finally(() => {
                dispatch(getJournal({id}));
            });
    }

    async function saveLessonsToJournal() {
        message.loading(<IntlMessage id={'changing'}/>, 0);
        await JournalService.saveLessonsToJournal(journal.id, lessonsForJournals)
            .then(() => {
                message.destroy();
                message.success(<IntlMessage id="success"/>, 5);
            })
            .catch(() => {
                message.destroy();
                message.error(<IntlMessage id="error"/>, 5);
            })
            .finally(() => {
                dispatch(getJournal({id}));
                setOpenAddLessonModal(false);
                lessonAddForm.resetFields();
            });
    }

    const onSelectAttendanceChange = id => {
        const exists = selectedAttendances.some(a => a === id);
        if (exists) {
            setSelectedAttendances(selectedAttendances.filter(a => a !== id));
        } else {
            setSelectedAttendances([...selectedAttendances, id]);
        }
    };
    // const rowSelection = {
    //     selectedRowKeys,
    //     onChange: onSelectChange,
    // };
    // const hasSelected = selectedRowKeys.length > 0;

    const handleChangeExcel = (info) => {
        setUploadedFile(info.file);
    };

    const propsExcelFile = {
        beforeUpload: () => false,
        onChange: handleChangeExcel,
        multiple: false,
    };

    const handleImportExcelFile = async () => {
        message.loading(<IntlMessage id={'loading'}/>, 0);
        await JournalService.importLessonsByExcel(journal.id, uploadedFile)
            .then(() => {
                message.destroy();
                message.success(<IntlMessage id={'success'}/>, 5)
                setUploadedFile(null);
            })
            .catch()
            .finally(() => {
                dispatch(getJournal({id}));
            })
    }

    return (
        <div style={{width: '100%', display: "flex", gap: 20}}>
            <BlockLoading isLoading={isLoading}/>
            <Form form={formAttendance} initialValues={initialAttendanceValues}
                  style={{display: "flex", flex: 1, width: '50%', flexDirection: "column", gap: 20}}>
                <div ref={tableRef}>
                    <Table
                        bordered
                        className={styles.customTable}
                        pagination={false}
                        columns={columns1}
                        dataSource={dataSource1}
                        scroll={{x: 'max-content'}}
                        size="small"
                    />
                </div>
                <Flex gap={"small"}>
                    <Button type="primary" onClick={saveAttendances}>
                        <IntlMessage id={'save'}/>
                    </Button>
                    {user?.role?.roleName === 'admin' && (
                        <Button
                            type={isAdminEditMode ? "default" : "primary"}
                            onClick={() => setIsAdminEditMode(!isAdminEditMode)}
                        >
                            {isAdminEditMode ? <IntlMessage id={'cancel'}/> : <IntlMessage id={'edit'}/>}
                        </Button>
                    )}
                </Flex>
            </Form>
            <div style={{display: "flex", flex: 1, width: '50%', gap: 20, flexDirection: "column"}}>
                {((journal?.group?.category?.nameEng === 'General English' || journal?.group?.category?.nameEng === 'Mathematics') && journal?.lessonWithDate === journal?.lessons?.length) &&
                    <Popconfirm
                        title={t('finishLessons')}
                        description={t('youSureToFinishLessons')}
                        onConfirm={finishAllLessons}
                        // className={classes.deleteBlock}
                        okText={t('yes')}
                        cancelText={t('no')}
                    >
                        <Button type={"primary"} style={{justifySelf: "flex-end"}}>
                            <IntlMessage id={'finishLessons'}/></Button>
                    </Popconfirm>
                }
                {(journal?.group?.category?.nameEng !== 'General English' && journal?.group?.category?.nameEng !== 'Mathematics' && journal?.group?.category?.nameEng !== 'Foundation') &&
                    <Button type={"primary"} style={{justifySelf: "flex-end"}}
                            onClick={() => setOpenAddLessonModal(true)}>
                        <IntlMessage id={'tg.addLesson'}/>
                    </Button>
                }
                {(journal?.group?.category?.nameEng === 'Foundation' && user?.role.roleName === 'admin') &&
                    <Flex justify={"space-around"} style={{width:'100%'}} gap={"small"}>
                        <Upload {...propsExcelFile} fileList={uploadedFile ? [uploadedFile] : []}>
                            <GreenButton>
                                <IntlMessage id={'certificate.excelFormat'}/>
                            </GreenButton>
                        </Upload>
                        <GreyButton disabled={uploadedFile == null} onClick={handleImportExcelFile}>
                            <IntlMessage id={'upload'}/>
                        </GreyButton>
                    </Flex>
                }
                <Form form={form} component={false}>
                    <Table
                        bordered
                        components={{
                            body: {cell: EditableCell},
                        }}
                        className={styles.customTable}
                        pagination={false}
                        columns={mergedColumns}
                        dataSource={dataSource2}
                        scroll={{x: true}}
                        size="small"
                    />
                </Form>
            </div>
            <Modal
                width={1000}
                maskClosable={true}
                title={<IntlMessage id={'tg.addLesson'}/>}
                open={openAddLessonModal}
                okText={<IntlMessage id={'save'}/>}
                cancelText={<IntlMessage id={'close'}/>}
                onOk={() => {
                    setOpenAddLessonModal(false);
                }}
                onCancel={() => {
                    setOpenAddLessonModal(false);
                }}
                footer={
                    <Button key="submit" type="primary" onClick={saveLessonsToJournal}>
                        <IntlMessage id={"save"}/>
                    </Button>
                }
            >
                {
                    openAddLessonModal &&
                    <Form form={lessonAddForm} className={classes.form} style={{overflowY: 'auto', maxHeight: 500}}>
                        <Form.List name="lessonsForJournals" rules={[{required: true, message: t('requiredField')}]}>
                            {(fields, {add, remove}) => (
                                <Flex vertical gap={10} style={{width: '100%'}}>
                                    {fields.map(({key, name, ...restField}, index) => {
                                        // Динамически вычисляем номер урока
                                        // const lessonNumber = (journal?.lessons?.length || 0) + index + 1;

                                        return (
                                            <Flex key={key} gap={"small"} justify={"flex-start"} align={"baseline"}
                                                  vertical
                                                  style={{
                                                      width: "100%",
                                                      padding: 8,
                                                      border: '1px solid white',
                                                      borderRadius: 8,
                                                      backgroundColor: "white"
                                                  }}>
                                                {/*<Form.Item*/}
                                                {/*    {...restField}*/}
                                                {/*    name={[name, "lessonNumberAddLesson"]}*/}
                                                {/*    className={classes.formInputBlock}*/}
                                                {/*    label={t('tg.lessonNumber')}*/}
                                                {/*    initialValue={lessonNumber}*/}
                                                {/*>*/}
                                                {/*    <Input*/}
                                                {/*        type={'number'}*/}
                                                {/*        className={classes.formInput}*/}
                                                {/*    />*/}
                                                {/*</Form.Item>*/}
                                                <Form.Item {...restField} name={[name, "topicNameAddLesson"]}
                                                           className={classes.formInputBlock}
                                                           label={t('tg.lessonTopic')}>
                                                    <Input className={classes.formInput}/>
                                                </Form.Item>
                                                <Form.Item {...restField} name={[name, "moduleNameAddLesson"]}
                                                           className={classes.formInputBlock}
                                                           label={t('tg.moduleOfLesson')}>
                                                    <Input className={classes.formInput}/>
                                                </Form.Item>
                                                <Form.Item {...restField} name={[name, "numberOfHoursAddLesson"]}
                                                           className={classes.formInputBlock} label={t('numOfHours')}>
                                                    <Input type={'number'} className={classes.formInput}/>
                                                </Form.Item>
                                                <Form.Item {...restField} name={[name, "lessonDateAddLesson"]}
                                                           className={classes.formInputBlock}
                                                           label={t('tg.lessonDate')}>
                                                    <Input type={'date'}/>
                                                </Form.Item>
                                                <Button danger variant="filled" onClick={() => remove(name)} block>
                                                    <IntlMessage id={"delete"}/>
                                                </Button>
                                            </Flex>
                                        );
                                    })}
                                    <Form.Item>
                                        <Button type="dashed" onClick={() => add()} block icon={<PlusOutlined/>}>
                                            <IntlMessage id={"certificate.addField"}/>
                                        </Button>
                                    </Form.Item>
                                </Flex>
                            )}
                        </Form.List>
                    </Form>
                }
            </Modal>
            <Modal
                width={400}
                maskClosable={true}
                title={<IntlMessage id={'noteLesson'}/>}
                open={openNoteLessonModal}
                okText={<IntlMessage id={'save'}/>}
                cancelText={<IntlMessage id={'close'}/>}
                onOk={() => {
                    setOpenNoteLessonModal(false);
                    setNoteLesson(null);
                    setIsViewNote(false)
                }}
                onCancel={() => {
                    setOpenNoteLessonModal(false);
                    setNoteLesson(null);
                    setIsViewNote(false)
                }}
                footer={!isViewNote && [
                    <Button key="submit" type="primary" onClick={() => makeAbsentForReason()}>
                        <IntlMessage id={"save"}/>
                    </Button>
                ]}
            >
                {
                    openNoteLessonModal && (noteLesson || isViewNote) &&
                    <Form form={reasonForm} className={classes.form}>
                        <Form.Item name="reason" className={classes.formInputBlock}>
                            <Input.TextArea className={classes.formInput} disabled={isViewNote}/>
                        </Form.Item>
                    </Form>
                }
            </Modal>
            {/* п.10: полное расписание ученика по всем дисциплинам (клик по ФИО) */}
            <StudentScheduleModal
                open={openSchedule}
                onClose={() => setOpenSchedule(false)}
                studentId={scheduleStudent?.id}
                studentName={scheduleStudent?.name}
            />
        </div>
    );
};

export default JournalPage;